import React, { useState, useEffect } from 'react';
import { MDBBtn, MDBInput } from 'mdb-react-ui-kit';
import './Chronometer.css';
//import 'font-awesome/css/font-awesome.min.css'; // Importing Font Awesome

export default function Chronometer({ initialTime = 1 * 60 * 60 }) {
  const [time, setTime] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editHours, setEditHours] = useState(Math.floor(initialTime / 3600));
  const [editMinutes, setEditMinutes] = useState(Math.floor((initialTime % 3600) / 60));
  const [editSeconds, setEditSeconds] = useState(initialTime % 60);
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    if (!isRunning) {
      return;
    }

    const interval = setInterval(() => {
      setTime(prevTime => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning]);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}:${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
  };

  const handleStart = () => {
    setIsRunning(true);
  };

  const handleStop = () => {
    setIsRunning(false);
  };

  const handleReset = () => {
    setIsRunning(false);
    setTime(initialTime);
  };

  const handleEdit = () => {
    setIsEditing(true);
    setIsRunning(false);
  };

  const handleSave = () => {
    const newTime = editHours * 3600 + editMinutes * 60 + editSeconds;
    setTime(newTime);
    setIsEditing(false);
  };

  const handleMaximize = () => {
    setIsMaximized(true);
  };

  const handleRestore = () => {
    setIsMaximized(false);
  };

  return (
    <div className={`chronometer ${isMaximized ? 'maximized' : ''}`}>
      <h2 className="chronometer-time">Tiempo de Juego</h2>
      {isEditing ? (
        <div className="edit-time">
          <MDBInput
            type="number"
            value={editHours}
            onChange={(e) => setEditHours(Number(e.target.value))}
            min="0"
            placeholder="HH"
            style={{paddingLeft: '5px', paddingRight: '5px'}} 
          />
          <span>:</span>
          <MDBInput
            type="number"
            value={editMinutes}
            onChange={(e) => setEditMinutes(Number(e.target.value))}
            min="0"
            max="59"
            placeholder="MM"
            style={{paddingLeft: '5px', paddingRight: '5px'}} 
          />
          <span>:</span>
          <MDBInput
            type="number"
            value={editSeconds}
            onChange={(e) => setEditSeconds(Number(e.target.value))}
            min="0"
            max="59"
            placeholder="SS"
            style={{paddingLeft: '5px', paddingRight: '5px'}} 
          />
          <MDBBtn className="btn chronometer-buttons" onClick={handleSave}>
            <i className="fas fa-save"></i>
          </MDBBtn>
        </div>
      ) : (
        <>
          <div className="time-display">{formatTime(time)}</div>
          <div className="buttons">
            <MDBBtn className="musButton-xm-icon" style={{marginRight:'10px'}} onClick={handleEdit} disabled={isRunning}>
              <i className="fas fa-edit"></i>
            </MDBBtn>
            {isMaximized ? (
              <MDBBtn className="musButton-xm-icon" style={{marginRight:'10px'}} onClick={handleRestore}>
                <i className="fas fa-compress"></i>
              </MDBBtn>
            ) : (
              <MDBBtn className="musButton-xm-icon" style={{marginRight:'10px'}} onClick={handleMaximize}>
                <i className="fas fa-expand"></i>
              </MDBBtn>
            )}

            <MDBBtn className="musButton-xm-icon" style={{marginRight:'10px'}} onClick={handleStart} disabled={isRunning}>
              <i className="fas fa-play"></i>
            </MDBBtn>
            <MDBBtn className="musButton-xm-icon" style={{marginRight:'10px'}} onClick={handleStop} disabled={!isRunning}>
              <i className="fas fa-pause"></i>
            </MDBBtn>
            <MDBBtn className="musButton-xm-icon" onClick={handleReset} disabled={isRunning}>
              <i className="fas fa-redo"></i>
            </MDBBtn>
          </div>
        </>
      )}
    </div>
  );
}